import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Sparkles } from 'lucide-react';

interface PoweredByLukProps {
  className?: string;
  variant?: 'light' | 'dark' | 'glass';
}

const PoweredByLuk: React.FC<PoweredByLukProps> = ({ className = '', variant = 'glass' }) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'light':
        return 'bg-white border-slate-200 text-slate-800 shadow-sm';
      case 'dark':
        return 'bg-slate-950 border-slate-800 text-slate-200 shadow-xl';
      case 'glass':
      default:
        return 'bg-white/10 backdrop-blur-md border border-white/20 text-white shadow-xl shadow-purple-500/10';
    }
  };

  const getIconColor = () => {
    switch (variant) {
      case 'light':
        return 'text-purple-600';
      case 'dark':
        return 'text-purple-400';
      case 'glass':
      default:
        return 'text-purple-300';
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      whileHover={{ scale: 1.05 }}
      className={`inline-flex items-center gap-2.5 px-3 py-1.5 rounded-full ${getVariantStyles()} ${className} transition-all duration-300 group cursor-default`}
    >
      <div className={`relative flex items-center justify-center ${getIconColor()} group-hover:scale-110 transition-transform duration-300`}>
        <div className="absolute inset-0 bg-purple-500/20 blur-sm rounded-full scale-150 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <Brain size={14} className="relative z-10" />
      </div>
      
      <div className="flex flex-col relative z-10">
        <span className="text-[7px] font-black uppercase tracking-[0.25em] opacity-60 leading-none mb-[2px]">Integrado com</span>
        <span className="text-[10px] font-bold tracking-wider leading-none flex items-center gap-1">
          LukIA <Sparkles size={8} className="opacity-0 group-hover:opacity-100 transition-opacity text-purple-400" />
        </span>
      </div>
    </motion.div>
  );
};

export default PoweredByLuk;
